import { DeleteAccountApplicationDocumentDto, GetAccountApplicationDto } from 'src/dtos';
import { AccountApplication } from 'src/models';

import { createAction, State, Type } from './utils';

export const doGetAccountApplication = (payload: GetAccountApplicationDto) =>
  createAction(State.actionRequested(Type.GET_ACCOUNT_APPLICATION), payload);

export const doSucceededGetAccountApplication = (payload: AccountApplication) =>
  createAction(State.actionSucceeded(Type.GET_ACCOUNT_APPLICATION), payload);

export const doFailedGetAccountApplication = (payload: GetAccountApplicationDto) =>
  createAction(State.actionFailed(Type.GET_ACCOUNT_APPLICATION), payload);

export const doRefreshAccountApplication = (payload: GetAccountApplicationDto & { key: string; documentId: string }) =>
  createAction(Type.REFRESH_ACCOUNT_APPLICATION, payload);

export const doDeleteAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto & { key: string }) =>
  createAction(State.actionRequested(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doSucceededDeleteAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto) =>
  createAction(State.actionSucceeded(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doFailedDeleteAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto) =>
  createAction(State.actionFailed(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doClearDeleteAccountApplicationDocument = () =>
  createAction(State.actionCleared(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT));

export const doCancelAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto & { key: string }) =>
  createAction(State.actionRequested(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doSucceededCancelAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto) =>
  createAction(State.actionSucceeded(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doFailedCancelAccountApplicationDocument = (payload: DeleteAccountApplicationDocumentDto) =>
  createAction(State.actionFailed(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT), payload);

export const doClearCancelAccountApplicationDocument = () =>
  createAction(State.actionCleared(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT));
